import { SVGProps } from 'react';

const SvgLongArrowLeft = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8" {...props}>
        <path d="M4.42 8V4.8h7.136l.024-1.608H4.42V0l-4 4 4 4Z" />
    </svg>
);
export default SvgLongArrowLeft;
